// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.success-container {
  width: 100%;
  height: 100vh;
}
.success-container .image-container {
  width: 100%;
}
.success-container .message {
  font-weight: bold;
  color: #fff;
}
.success-container .back-indicator {
  font-size: 12px;
}

.info {
  color: #85e7ca;
  font-size: 16px;
}

.alert {
  color: #f39652;
  font-size: 16px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/components/success/success.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;AACF;AACE;EACE,WAAA;AACJ;AACE;EACE,iBAAA;EACA,WAAA;AACJ;AAEE;EACE,eAAA;AAAJ;;AAIA;EACE,cAAA;EACA,eAAA;AADF;;AAGA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AAAF","sourcesContent":[".success-container {\r\n  width: 100%;\r\n  height: 100vh;\r\n\r\n  .image-container {\r\n    width: 100%;\r\n  }\r\n  .message {\r\n    font-weight: bold;\r\n    color: #fff;\r\n  }\r\n\r\n  .back-indicator {\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n.info {\r\n  color: #85e7ca;\r\n  font-size: 16px;\r\n}\r\n.alert {\r\n  color: #f39652;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
